module.exports = {"id":"dp2_2l1q6","text":"Sharing Through Digital Technologies","instructions":"Before sharing information online, why is it useful to consider the purpose and audience?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"2.2","questionType":"PickOne","random":true,"options":[{"id":"dp2_2l1q6-a1","text":"To ensure the content is appropriate and relevant","score":1.8},{"id":"dp2_2l1q6-a2","text":"To increase file size when sharing","score":0},{"id":"dp2_2l1q6-a3","text":"To avoid using digital platforms","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.2/l1q6.json
// module id = 1015
// module chunks = 41